import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

export const okrsModule = {
  namespaced: true,
  state: {
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    // 残す
    [getterConstants.ADD_RELATION]: firebaseAction((context, value) => {
      console.log('addrelation', value)
      const targetOkrRef = db.ref(
        value.type +
        '/' + context.rootState.currentUserId +
        '/' + value.key +
        '/relations'
      )
      console.log('ref', targetOkrRef)
      value.relationInfo.dir = 'dst'
      targetOkrRef.push(value.relationInfo)
    }),
    // 残す
    [getterConstants.REMOVE_RELATION]: firebaseAction((context, value) => {
      console.log('hoge', value)
      const targetOkrRef = db.ref(
        value.type +
        '/' + context.rootState.currentUserId +
        '/' + value.key +
        '/relations/' + value.relationKey
      )
      targetOkrRef.remove()
    }),
    // 残す
    [getterConstants.SET_ITEM_COMPLETENESS]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      let target = {
        isComplete: value.isComplete,
        modifiedAt: value.modifiedAt
      }
      const setItemRef = db
        .ref(value.target + '/' + currentUserId)
        .child(value.id)
      setItemRef.update(target)
      // const setItemRef = db
      //   .ref(value.target + '/' + currentUserId)
      //   .child(value.id)
      //   .child('isComplete')
      // setItemRef.set(value.isComplete)
      if (value.parentObjId) {
        const setParentCompRef = db
          .ref('objectives/' + currentUserId + '/' + value.parentObjId + '/keyresults/' + value.id)
          .child('isComplete')
        setParentCompRef.set(value.isComplete)
      }
    }),
    // 残す
    [getterConstants.REMOVE_ITEM_ISCOMPLETE]: firebaseAction((context, value) => {
      console.log(value.target, value.id)
      const currentUserId = context.rootState.currentUserId
      const removeTargetRef = db
        .ref(value.target + '/' + currentUserId)
        .child(value.id)
        .child('isComplete')
      removeTargetRef.remove()
      if (value.parentObjId) {
        const removeParentCompRef = db
          .ref('objectives/' + currentUserId + '/' + value.parentObjId + '/keyresults/' + value.id)
        removeParentCompRef.set(1)
      }
    }),
    // 残す
    [getterConstants.SET_ITEM_PROGRESS]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const setItemRef = db
        .ref(value.target + '/' + currentUserId)
        .child(value.id)
        .child('progress')
      setItemRef.set(value.progress)
    })
  },
  getters: {
    // 残す
    getIsReadRelation: (state, getters, rootState) => (targetType, targetOwner, targetId, relationKey) => {
      let okr
      try {
        okr = rootState.readTimes['relations'][targetType][targetOwner][targetId][relationKey]
      } catch (e) {
        return false
      }
      return !!okr
    },
    // 残す
    getRelationInfo: (state, getters, rootState) => (targetIdUserIds, userInfos) => {
      // targetIdUserIdsは {targetId, userId, type}をキーにもつオブジェクトの配列
      let relations = []
      for (let i in targetIdUserIds) {
        const userInfo = userInfos[targetIdUserIds[i]['userId']].userInfo
        let relation = {
          userId: targetIdUserIds[i]['userId'],
          // userIcon: userInfo.userIcon,
          username: userInfo.userName,
          type: targetIdUserIds[i]['type'],
          key: targetIdUserIds[i]['targetId']
        }
        if (userInfo.userIcon) {
          relation.userIcon = userInfo.userIcon
        } else {
          relation.userIcon = ''
        }
        relations.push(relation)
      }
      return relations
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/okrs.js